module.exports = {
    'color-1': {
        name: 'Color 1',
        fillAll: true,
        placeholderColor: 'rgb(212,208,203)',
        border: [
            [0, 0],
            [2, 0],
            [2, 2],
            [0, 2],
            [0, 0],
            [0, 2],
            [2, 2],
            [2, 4],
            [0, 4],
            [0, 2],
            [0, 4],
            [2, 4],
            [2, 6],
            [0, 6],
            [0, 4],
            [0, 6],
            [2, 6],
            [2, 8],
            [0, 8],
            [0, 6],
            [0, 0],

            [4, 0],
            [4, 2],
            [2, 2],
            [2, 0],
            [2, 2],
            [4, 2],
            [4, 4],
            [2, 4],
            [2, 2],
            [2, 4],
            [4, 4],
            [4, 6],
            [2, 6],
            [2, 4],
            [2, 6],
            [4, 6],
            [4, 8],
            [2, 8],
            [2, 6],
            [2, 0],

            [6, 0],
            [6, 2],
            [4, 2],
            [4, 0],
            [4, 2],
            [6, 2],
            [6, 4],
            [4, 4],
            [4, 2],
            [4, 4],
            [6, 4],
            [6, 6],
            [4, 6],
            [4, 4],
            [4, 6],
            [6, 6],
            [6, 8],
            [4, 8],
            [4, 6],
            [4, 0],
            [6, 0],

            [8, 0],
            [8, 2],
            [6, 2],
            [6, 0],
            [6, 2],
            [8, 2],
            [8, 4],
            [6, 4],
            [6, 2],
            [6, 4],
            [8, 4],
            [8, 6],
            [6, 6],
            [6, 4],
            [6, 6],
            [8, 6],
            [8, 8],
            [6, 8],
            [6, 0],

            [12, 0],
            [12, 12],
            [14, 12],
            [14, 14],
            [12, 14],
            [12, 12],
            [12, 14],
            [14, 14],
            [14, 16],
            [12, 16],
            [12, 14],
            [12, 16],
            [14, 16],
            [14, 18],
            [12, 18],
            [12, 16],
            [12, 18],
            [14, 18],
            [14, 20],
            [12, 20],
            [12, 18],
            [12, 20],
            [14, 20],
            [14, 22],
            [12, 22],
            [12, 20],
            [12, 22],
            [14, 22],
            [14, 24],
            [12, 24],
            [12, 22],
            [12, 24],

            [12, 12],
            [16, 12],
            [16, 14],
            [14, 14],
            [14, 12],
            [14, 14],
            [16, 14],
            [16, 16],
            [14, 16],
            [14, 14],
            [14, 16],
            [16, 16],
            [16, 18],
            [14, 18],
            [14, 16],
            [14, 18],
            [16, 18],
            [16, 20],
            [14, 20],
            [14, 18],
            [14, 20],
            [16, 20],
            [16, 22],
            [14, 22],
            [14, 20],
            [14, 22],
            [16, 22],
            [16, 24],
            [14, 24],
            [14, 22],
            [14, 12],

            [18, 12],
            [18, 14],
            [16, 14],
            [16, 12],
            [16, 14],
            [18, 14],
            [18, 16],
            [16, 16],
            [16, 14],
            [16, 16],
            [16, 12],

            [20, 12],
            [20, 14],
            [18, 14],
            [18, 12],
            [18, 14],
            [20, 14],
            [20, 16],
            [18, 16],
            [18, 12],

            [22, 12],
            [22, 14],
            [20, 14],
            [20, 12],
            [20, 14],
            [22, 14],
            [22, 16],
            [20, 16],
            [20, 12],

            [24, 12],
            [24, 14],
            [22, 14],
            [22, 12],
            [22, 14],
            [24, 14],
            [24, 16],
            [22, 16],
            [22, 12],
            [22, 16],
            [22, 12],
            [12, 12],
            [12, 0]
        ]
    },
    'color-2': {
        name: 'Color 2',
        fillAll: true,
        placeholderColor: 'rgb(159,160,162)',
        border: [
            [0, 0],
            [0, 12],
            [2, 12],
            [2, 14],
            [0, 14],
            [0, 12],
            [0, 14],
            [2, 14],
            [2, 16],
            [0, 16],
            [0, 14],

            [0, 12],
            [4, 12],
            [4, 14],
            [2, 14],
            [2, 12],
            [2, 14],
            [4, 14],
            [4, 16],
            [2, 16],
            [2, 14],

            [2, 12],
            [6, 12],
            [6, 14],
            [4, 14],
            [4, 12],
            [4, 14],
            [6, 14],
            [6, 16],
            [4, 16],
            [4, 14],
            [4, 12],

            [8, 12],
            [8, 14],
            [6, 14],
            [6, 12],
            [6, 14],
            [8, 14],
            [8, 16],
            [6, 16],
            [6, 14],
            [6, 12],

            [8, 12],
            [10, 12],
            [10, 14],
            [8, 14],
            [8, 12],
            [8, 14],
            [10, 14],
            [10, 16],
            [8, 16],
            [8, 14],
            [8, 16],
            [10, 16],
            [10, 18],
            [8, 18],
            [8, 16],
            [8, 18],
            [10, 18],
            [10, 20],
            [8, 20],
            [8, 18],
            [8, 20],
            [10, 20],
            [10, 22],
            [8, 22],
            [8, 20],
            [8, 22],
            [10, 22],
            [10, 24],
            [8, 24],
            [8, 22],
            [8, 24],
            [8, 12],

            [12, 12],
            [12, 14],
            [10, 14],
            [10, 12],
            [10, 14],
            [12, 14],
            [12, 16],
            [10, 16],
            [10, 14],
            [10, 16],
            [12, 16],
            [12, 18],
            [10, 18],
            [10, 16],
            [10, 18],
            [12, 18],
            [12, 20],
            [10, 20],
            [10, 18],
            [10, 20],
            [12, 20],
            [12, 22],
            [10, 22],
            [10, 20],
            [10, 22],
            [12, 22],
            [12, 24],
            [10, 24],
            [10, 22],
            [10, 24],
            [10, 12],
            [0, 12],
            [0, 0],

            [18, 0],

            [18, 2],
            [16, 2],
            [16, 0],
            [16, 2],
            [18, 2],
            [18, 4],
            [16, 4],
            [16, 2],
            [16, 4],
            [18, 4],
            [18, 6],
            [16, 6],
            [16, 4],
            [16, 6],
            [18, 6],
            [18, 8],
            [16, 8],
            [16, 6],
            [16, 8],

            [16, 0],
            [20, 0],
            [20, 2],
            [18, 2],
            [18, 0],
            [18, 2],
            [20, 2],
            [20, 4],
            [18, 4],
            [18, 2],
            [18, 4],
            [20, 4],
            [20, 6],
            [18, 6],
            [18, 4],
            [18, 6],
            [20, 6],
            [20, 8],
            [18, 8],
            [18, 6],
            [18, 0],

            [20, 0],
            [22, 0],
            [22, 2],
            [20, 2],
            [20, 0],
            [20, 2],
            [22, 2],
            [22, 4],
            [20, 4],
            [20, 2],
            [20, 4],
            [22, 4],
            [22, 6],
            [20, 6],
            [20, 4],
            [20, 6],
            [22, 6],
            [22, 8],
            [20, 8],
            [20, 6],
            [20, 0],

            [22, 0],
            [24, 0],
            [24, 2],
            [22, 2],
            [22, 0],
            [22, 2],
            [24, 2],
            [24, 4],
            [22, 4],
            [22, 2],
            [22, 4],
            [24, 4],
            [24, 6],
            [22, 6],
            [22, 4],
            [22, 6],
            [24, 6],
            [24, 8],
            [22, 8],
            [22, 6],
            [22, 8],
            [22, 0]

        ]
    },
    'color-3': {
        name: 'Color 3',
        fillAll: true,
        placeholderColor: 'rgb(106,106,110)',
        border: [
            [0, 0],
            [0, 8],
            [2, 8],
            [2, 10],
            [0, 10],
            [0, 8],
            [0, 10],
            [2, 10],
            [2, 12],
            [0, 12],
            [0, 10],

            [0, 8],
            [4, 8],
            [4, 10],
            [2, 10],
            [2, 8],
            [2, 10],
            [4, 10],
            [4, 12],
            [2, 12],
            [2, 10],
            [2, 8],
            [2, 10],
            [4, 10],
            [4, 8],
            
            [6, 8],
            [6, 10],
            [4, 10],
            [4, 8],
            [4, 10],
            [6, 10],
            [6, 12],
            [4, 12],
            [4, 10],
            [4, 8],
            [2, 8],
            [2, 10],
            [4, 10],
            [4, 12],
            [4, 8],

            [6, 8],
            [8, 8],
            [8, 10],
            [6, 10],
            [6, 8],
            [6, 10],
            [8, 10],
            [8, 12],
            [6, 12],
            [6, 10],
            [6, 8],
            [0, 8],
            [0, 0],
            
            [10, 0],
            [10, 2],
            [8, 2],
            [8, 0],
            [8, 2],
            [10, 2],
            [10, 4],
            [8, 4],
            [8, 2],
            [8, 4],
            [   10, 4],
            [10, 6],
            [8, 6],
            [8, 4],
            [8, 6],
            [10, 6],
            [10, 8],
            [8, 8],
            [8, 6],
            [8, 8],
            [10, 8],
            [10, 10],
            [8, 10],
            [8, 8],
            [8, 10],
            [10, 10],
            [10, 12],
            [8, 12],
            [8, 10],
            [8, 0],

            [12, 0],
            [12, 2],
            [10, 2],
            [10, 0],
            [10, 2],
            [12, 2],
            [12, 4],
            [10, 4],
            [10, 2],
            [10, 4],
            [12, 4],
            [12, 6],
            [10, 6],
            [10, 4],
            [10, 6],
            [12, 6],
            [12, 8],
            [10, 8],
            [10, 6],
            [10, 8],
            [12, 8],
            [12, 10],
            [10, 10],
            [10, 8],
            [10, 10],
            [12, 10],
            [12, 12],
            [10, 12],
            [10, 0],
            [16, 0],

            [16, 16], 
            [18, 16],
            [18, 18],
            [16, 18],
            [16, 16],
            [16, 18],
            [18, 18],
            [18, 20],
            [16, 20],
            [16, 18],
            [16, 20],
            [18, 20],
            [18, 22],
            [16, 22],
            [16, 20],
            [16, 22],
            [18, 22],
            [18, 24],
            [16, 24],
            [16, 22],
            [16, 16],

            [20, 16],
            [20, 18],
            [18, 18],
            [18, 16],
            [18, 18],
            [20, 18],
            [20, 20],
            [18, 20],
            [18, 18],
            [18, 20],
            [20, 20],
            [20, 22],
            [18, 22],
            [18, 20],
            [18, 22],
            [20, 22],
            [20, 24],
            [18, 24],
            [18, 22],
            [18, 16],

            [22, 16],
            [22, 18],
            [20, 18],
            [20, 16],
            [20, 18],
            [22, 18],
            [22, 20],
            [20, 20],
            [20, 18],
            [20, 20],
            [22, 20],
            [22, 22],
            [20, 22],
            [20, 20],
            [20, 22],
            [22, 22],
            [22, 24],
            [20, 24],
            [20, 16],

            [24, 16],
            [24, 18],
            [22, 18],
            [22, 16],
            [22, 18],
            [24, 18],
            [24, 20],
            [22, 20],
            [22, 18],
            [22, 20],
            [24, 20],
            [24, 22],
            [22, 22],
            [22, 20],
            [22, 22],
            [24, 22],
            [24, 24],
            [22, 24],
            [22, 22],
            [22, 16],

            [16,16],
            [16, 0],
        ]
    },
    'color-4': {
        name: 'Color 4',
        fillAll: true,
        placeholderColor: 'rgb(61,67,71)',
        border: [
            [0, 0],
            [0, 16],
            [2, 16],
            [2, 18],
            [0, 18],
            [0, 16],
            [0, 18],
            [2, 18],
            [2, 20],
            [0, 20],
            [0, 18],
            [0, 20],
            [2, 20],
            [2, 22],
            [0, 22],
            [0, 20],
            [0, 22],
            [2, 22],
            [2, 24],
            [0, 24],
            [0, 16],

            [4, 16],
            [4, 18],
            [2, 18],
            [2, 16],
            [2, 18],
            [   4, 18],
            [4, 20],
            [2, 20],
            [2, 18],
            [2, 20],
            [4, 20],
            [4, 22],
            [2, 22],
            [2, 20],
            [2, 22],
            [4, 22],
            [4, 24],
            [2, 24],
            [2, 22],
            [2, 16],

            [6, 16],
            [6, 18],
            [4, 18],
            [4, 16],
            [4, 18],
            [6, 18],
            [6, 20],
            [4, 20],
            [4, 18],
            [4, 20],
            [6, 20],
            [6, 22],
            [4, 22],
            [4, 20],
            [4, 22],
            [6, 22],
            [6, 24],
            [4, 24],
            [4, 16],

            [8, 16],
            [8, 18],
            [6, 18],
            [6, 16],
            [6, 18],
            [8, 18],
            [8, 20],
            [6, 20],
            [6, 18],
            [6, 20],
            [8, 20],
            [8, 22],
            [6, 22],
            [6, 20],
            [6, 22],
            [8, 22],
            [8, 24],
            [6, 24],
            [6, 22],
            [6, 16],

            [0, 16],

            [0, 0],
            [14, 0], 
            [14, 2],
            [12, 2],
            [12, 0],
            [12, 2],
            [14, 2],
            [   14, 4],
            [12, 4],
            [12, 2],
            [12, 4],
            [14, 4],
            [14, 6],
            [12, 6],
            [12, 4],
            [12, 6],
            [14, 6],
            [14, 8],
            [12, 8],
            [12, 6],
            [12, 8],
            [14, 8],
            [14, 10],
            [12, 10],
            [12, 8],
            [12, 10],
            [14, 10],
            [14, 12],
            [12, 12],
            [12, 10],
            [12, 0],

            [16, 0],
            [16, 2],
            [14, 2],
            [14, 0],
            [14, 2],
            [16, 2],
            [16, 4],
            [14, 4],
            [14, 2],
            [14, 4],
            [16, 4],
            [16, 6],
            [14, 6],
            [14, 4],
            [14, 6],
            [16, 6],
            [16, 8],
            [14, 8],
            [14, 6],
            [14, 8],
            [16, 8],
            [16, 10],
            [14, 10],
            [14, 8],
            [14, 10],
            [16, 10],
            [16, 12],
            [14, 12],
            [14, 10],
            [14, 0],

            [16, 0],
            [16, 8], 
            [18, 8],
            [18, 10],
            [16, 10],
            [16, 8],
            [16, 10],
            [18, 10],
            [18, 12],
            [16, 12],
            [16, 8],

            [20, 8],
            [20, 10],
            [18, 10],
            [18, 8],
            [18, 10],
            [20, 10],
            [20, 12],
            [18, 12],
            [18, 10],
            [18, 8],
            
            [22, 8],
            [22, 10],
            [20, 10],
            [20, 8],
            [20, 10],
            [22, 10],
            [22, 12],
            [20, 12],
            [20, 10],
            [20, 8],

            [24, 8],
            [24, 10],
            [22, 10],
            [22, 8],
            [22, 10],
            [24, 10],
            [24, 12],
            [22, 12],
            [22, 10],
            [22, 8],
            [16, 8],
            [16, 0],
            [0, 0]
        ]
    },
}



// WEBPACK FOOTER //
// ./src/universal/filzfelt/blocks/waffle.js